import cameraPermissionEn from './en/camera-permission.json';
import exerciseEn from './en/exercise.json';
import tryDemoEn from './en/try-demo.json';
import cameraPermissionAr from './ar/camera-permission.json';
import exerciseAr from './ar/exercise.json';
import tryDemoAr from './ar/try-demo.json';

/** inPerformance is small enough to bundle every namespace up front — no lazy loading needed. */
export const inPerformanceResources = {
  en: {
    'camera-permission': cameraPermissionEn,
    exercise: exerciseEn,
    'try-demo': tryDemoEn,
  },
  ar: {
    'camera-permission': cameraPermissionAr,
    exercise: exerciseAr,
    'try-demo': tryDemoAr,
  },
};

export const inPerformanceNamespaces = Object.keys(inPerformanceResources.en);
